import { BoxProvider } from "../../Context/BoxContext"; // Import BoxProvider
import BoxWithContent from "../../Components/BoxWithContent"; // Import BoxWithContent component
import { useHrStyles } from "../../Context/HRContext";

export default function Engineering() {
  const hrStyles = useHrStyles();

  // First Box Content
  const heading = "Structural Engineering";
  const description =
    "Building the backbone of every structure with precision and integrity. At BEAMS, we specialize in designing and analyzing structural systems that prioritize safety, durability, and performance. Our team ensures that every framework stands the test of time.";
  const image = "/assets/images/structure.jpeg";
  const gradientColor = "#FDEFDB"; // Customize gradient color for first box
  const buttonVariant = "outline-info";
  const link1 = "/Structural"; // Link for the first box

  // Second Box Content
  const heading2 = "Civil Engineering";
  const description2 =
    "Designing sustainable and efficient infrastructures for a better tomorrow. BEAMS offers expert civil engineering services, from planning and development to material selection and execution, ensuring that every project is rooted in innovation and reliability.";
  const image2 = "/assets/images/civil.jpg"; // Image for the second box
  const gradientColor2 = "#FDEFDB"; // Customize gradient color for second box
  const buttonVariant2 = "outline-info ";
  const link2 = "/Civil"; // Link for the second box

  return (
    <>
      <BoxProvider
        heading={heading}
        description={description}
        image={image}
        gradientColor={gradientColor}
        buttonVariant={buttonVariant}
        link1={link1}
        heading2={heading2}
        description2={description2}
        image2={image2}
        gradientColor2={gradientColor2}
        buttonVariant2={buttonVariant2}
        link2={link2}
      >
        <hr style={hrStyles} />
        <p className="building-text">
          Engineering Excellence,
          <br />
          Built to Last
        </p>
        <hr style={hrStyles} />
        <p className="building-description">
          BEAMS brings unparalleled expertise to structural and civil
          engineering, ensuring strength, precision, and innovation in every
          project. Our engineering solutions are tailored to meet modern demands
          while upholding timeless quality.
        </p>
        <BoxWithContent />
      </BoxProvider>
    </>
  );
}
